import { createLucideIcon } from 'lucide-react';
export const UsersIcon = createLucideIcon('users-icon', [
  [
    'path',
    {
      d: 'M12 19C12 19 12 13 17 13C22 13 22 19 22 19',
      key: '1q99zg',
    },
  ],
  [
    'path',
    {
      d: 'M13 9C13 6.78906 14.7891 5 17 5C19.2109 5 21 6.78906 21 9C21 11.2109 19.2109 13 17 13C14.7891 13 13 11.2109 13 9Z',
      key: 'c2bpgg',
    },
  ],
  [
    'path',
    {
      d: 'M2 19C2 19 2 13 7 13C12 13 12 19 12 19',
      key: '1r2hkw',
    },
  ],
  [
    'path',
    {
      d: 'M3 9C3 6.78906 4.78906 5 7 5C9.21094 5 11 6.78906 11 9C11 11.2109 9.21094 13 7 13C4.78906 13 3 11.2109 3 9Z',
      key: 'yqf7k3',
    },
  ],
]);
